import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import moment from "moment";
// react component used to create sweet alerts
import SweetAlert from "react-bootstrap-sweetalert";

// reactstrap components
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Button,
} from "reactstrap";
import DefaultFooter from "../../Components/Footers/DefaultFooter";
import StravaActivitiesHeader from "../../Components/Headers/StravaActivitiesHeader";
import ScrollTransparentNavbar from "../../Components/Navbars/ScrollTransparentNavbar";

import Loader from "../../Components/UI/Loader";

import * as actions from "../../store/actions/index";

const displaySeconds = (seconds) => {
  const sDisplay =
    seconds > 0 ? (seconds < 10 ? "0" + seconds : seconds) : "00";
  return sDisplay;
};

const StravaActivities = (props) => {
  const [alert, setAlert] = useState(null);

  const selectRunAlert = (message, show, eventTime, distance) => {
    setAlert(
      <SweetAlert
        warning
        style={{
          display: "block",
          marginTop: "-100px",
          color: "rgb(89, 89, 89)",
        }}
        title="Use this run?"
        onConfirm={() => success(eventTime, distance)}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="info"
        cancelBtnBsStyle="danger"
        confirmBtnText="Yes"
        cancelBtnText="Cancel"
        show={show}
        showCancel
        reverseButtons
      >
        {message}
      </SweetAlert>
    );
  };

  const linkedStravaAlert = () => {
    setAlert(
      <SweetAlert
        success
        style={{
          display: "block",
          marginTop: "-100px",
          color: "rgb(89, 89, 89)",
        }}
        title="Success!!"
        onConfirm={() => hideStravaLinkedAlert()}
        onCancel={() => hideStravaLinkedAlert()}
        confirmBtnBsStyle="success"
        confirmBtnText="OK"
        show={true}
      >
        Successfully linked to Strava. Please go back to the event to capture
        your time, and select the Strava Upload method.
      </SweetAlert>
    );
  };

  const linkedStravaDeniedAlert = () => {
    setAlert(
      <SweetAlert
        error
        style={{
          display: "block",
          marginTop: "-100px",
          color: "rgb(89, 89, 89)",
        }}
        title="Access Denied!"
        onConfirm={() => hideStravaLinkedAlert()}
        onCancel={() => hideStravaLinkedAlert()}
        confirmBtnBsStyle="error"
        confirmBtnText="OK"
        show={true}
      >
        Access to Strava has been denied. You can capture your time manually or
        link your Strava account once you're ready.
      </SweetAlert>
    );
  };

  const hideAlert = () => {
    setAlert(null);
  };

  const hideStravaLinkedAlert = () => {
    setAlert(null);
    props.history.push("/Profile");
  };

  const successHideAlert = () => {
    props.onCaptureEventFinish();
    props.history.push("/Profile");
  };

  useEffect(() => {
    if (props.success) {
      setAlert(
        <SweetAlert
          success
          style={{ display: "block", marginTop: "-100px" }}
          title="Run saved!"
          onConfirm={() => successHideAlert()}
          onCancel={() => successHideAlert()}
          confirmBtnBsStyle="info"
        >
          Your run has been successfully saved.
        </SweetAlert>
      );
    }
  }, [props]);

  const success = (eventTime, distance) => {
    console.log("eventTime", props.selectedEvent);
    props.onSaveStravaEvent({
      item: {
        user: props.user,
        eventTime,
        distance,
        event: props.selectedEvent,
      },
    });
  };

  const calculatePace = (elapsed_time, distance) => {
    const timeInSeconds = elapsed_time;
    const distanceInMetres = distance;
    var pace = (timeInSeconds / distanceInMetres / 60) * 1000;
    var leftover = pace % 1;
    var minutes = pace - leftover;
    var seconds = Math.round(leftover * 60);
    displaySeconds(seconds);
    return minutes + ":" + displaySeconds(seconds);
  };

  let link = `http://www.strava.com/oauth/authorize?client_id=${process.env.REACT_APP_STRAVA_CLIENT_ID}&response_type=code&redirect_uri=${process.env.REACT_APP_STRAVA_REDIRECT_URL}&scope=activity:read_all&approval_prompt=auto`;

  useEffect(() => {
    debugger;

    const queryString = new URLSearchParams(window.location.search);

    const code = queryString.get("code");
    const error = queryString.get("error");

    const access_token = localStorage.getItem("access_token");
    const refresh_token = localStorage.getItem("refresh_token");

    const expirationDate = new Date(localStorage.getItem("expirationDate"));
    const tokenExpired = expirationDate <= new Date();

    if (!code && !access_token && error === null) {
      window.location.href = link;
    }

    if (error !== null) {
      linkedStravaDeniedAlert();
    }

    if (tokenExpired) {
      props.onGetStravaAuthCode(code, refresh_token, tokenExpired);
    }
  }, []);

  useEffect(() => {
    console.log("athlete here", props.athlete);
    const access_token = localStorage.getItem("access_token");
    if (
      props.athlete !== null &&
      access_token !== null &&
      props.selectedEvent === null
    ) {
      linkedStravaAlert();
      return;
    }
    if (props.athlete !== null && access_token !== null)
      props.onGetStravaActivities(
        access_token,
        props.selectedEvent.data.startDate,
        props.selectedEvent.data.endDate,
        props.selectedEvent.data.minMileage
      );
  }, [props.athlete]);

  let screen = (
    <Container>
      {alert}
      <Row>
        {props.activities.items.length === 0 ? (
          <h1>No data found </h1>
        ) : (
          props.activities.items.map((item) => (
            <Col lg="3" md="6" key={item.id}>
              <Card className="card-pricing" data-background-color="orange">
                <CardBody>
                  <CardTitle tag="h3">{item.name}</CardTitle>
                  <ul>
                    <li>
                      <i class="fas fa-road"></i>
                      Distance:&nbsp;{(item.distance * 0.001).toFixed(2)}
                      KM
                    </li>
                    <li>
                      <i class="fas fa-stopwatch"></i>
                      Avg Pace:&nbsp;
                      {calculatePace(item.moving_time, item.distance)}/KM
                    </li>
                    <li>
                      <i class="far fa-clock"></i>
                      Moving Time:&nbsp;
                      {new Date(item.moving_time * 1000)
                        .toISOString()
                        .substr(11, 8)}
                    </li>
                    <li>
                      <i class="fas fa-stopwatch"></i>
                      Avg Elapsed Pace:&nbsp;
                      {calculatePace(item.elapsed_time, item.distance)}
                      /KM
                    </li>
                    <li>
                      <i class="far fa-clock"></i>
                      Elapsed Time:&nbsp;
                      {new Date(item.elapsed_time * 1000)
                        .toISOString()
                        .substr(11, 8)}
                    </li>
                    <li>
                      <i class="far fa-calendar-alt"></i>
                      Date:&nbsp;
                      {moment(item.start_date_local).format("DD/MM/YYYY")}
                    </li>
                  </ul>
                  <Button
                    className="btn-neutral btn-round"
                    color="default"
                    href="#pablo"
                    onClick={(e) => {
                      e.preventDefault();
                      selectRunAlert(
                        item.name.concat(
                          " ",
                          moment(item.start_date_local).format("DD/MM/YYYY")
                        ),
                        true,
                        new Date(item.elapsed_time * 1000)
                          .toISOString()
                          .substr(11, 8)
                          .toString(),
                        (item.distance * 0.001).toFixed(2)
                      );
                    }}
                  >
                    Use Run
                  </Button>
                </CardBody>
              </Card>
            </Col>
          ))
        )}
      </Row>
    </Container>
  );
  console.log("isloading", props.loading);
  if (props.loading) {
    screen = <Loader />;
  }

  return (
    <>
      <ScrollTransparentNavbar />
      <div className="wrapper">
        <StravaActivitiesHeader />
        <div className="section">{screen}</div>
      </div>
      <DefaultFooter />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    athlete: state.strava.athlete,
    profileImage: state.strava.profileImage,
    firstName: state.strava.firstName,
    lastName: state.strava.lastName,
    city: state.strava.city,
    activities: state.strava.activities,
    authenticated: state.authentication.authenticated,
    selectedEvent: state.event.selectedEvent,
    user: state.authentication.user,
    success: state.capturedEvent.success,
    loading: state.strava.loading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onGetStravaAuthCode: (authCode, refresh_token, tokenExpired) =>
      dispatch(
        actions.getStravaAuthCode(authCode, refresh_token, tokenExpired)
      ),
    onGetStravaActivities: (
      access_token,
      startDate,
      endDate,
      minMileage,
      authCode,
      refresh_token,
      tokenExpired
    ) =>
      dispatch(
        actions.getStravaActivities(
          access_token,
          startDate,
          endDate,
          minMileage,
          authCode,
          refresh_token,
          tokenExpired
        )
      ),
    onGetStravaAthlete: (access_token) =>
      dispatch(actions.getStravaAthlete(access_token)),
    onSaveStravaEvent: (capturedEvent) =>
      dispatch(actions.saveStravaEvent(capturedEvent)),
    onCaptureEventFinish: () => dispatch(actions.captureEventFinish()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StravaActivities);
